import { useMutation, useQueryClient } from "@tanstack/react-query";

import { retireRunner } from "./api";
import { isRunnerNotFound } from "./errors";

// Снятие раннера с учёта. Инвалидируем `runners` (снятый пропадает из
// списка) и `queue` (его очередь пропадает из `GET /queue`). На `404`
// (раннер уже снят другим админом) список перечитывается тоже.
export function useRetireRunner(): ReturnType<
  typeof useMutation<void, Error, string>
> {
  const queryClient = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: (runnerId) => retireRunner(runnerId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["runners"] });
      void queryClient.invalidateQueries({ queryKey: ["queue"] });
    },
    onError: (err) => {
      if (isRunnerNotFound(err)) {
        void queryClient.invalidateQueries({ queryKey: ["runners"] });
      }
    },
  });
}
